export default class MigrationController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 */
	constructor($location, $routeParams) {
		this.$location = $location;
		this.$routeParams = $routeParams;

		const { act, ref } = $routeParams;

		if (act === 'PV') {
			this.$location.url(`/preview/K_NODE;${ref}`);
		}
	}
}
